import { render, staticRenderFns } from "./slittingStyle.vue?vue&type=template&id=578deaff&"
import script from "./slittingStyle.vue?vue&type=script&lang=js&"
export * from "./slittingStyle.vue?vue&type=script&lang=js&"
import style0 from "./slittingStyle.vue?vue&type=style&index=0&id=578deaff&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports